import api from 'api';

export const updateJobHack = (id, dto) => {
  return api.post(`/jobhack/${id}`, dto);
}
